import { render, staticRenderFns } from "./unitCreditHis.vue?vue&type=template&id=222d0500&scoped=true"
import script from "./unitCreditHis.vue?vue&type=script&lang=js"
export * from "./unitCreditHis.vue?vue&type=script&lang=js"
import style0 from "./unitCreditHis.vue?vue&type=style&index=0&id=222d0500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d0500",
  null
  
)

export default component.exports